import React from "react";

function FAQs() {
  return (
    <div>
      <section className="w-100 float-left faq-con faq-page-con pt-0">
        <div className="wrapper2 padding-top">
          <div className="generic-title text-center">
            <h2 data-aos="fade-up" data-aos-duration={600}>
              Frequently Asked Questions
            </h2>
          </div>
          <div className="faq-box">
            <div className="faq-content">
              <div id="accordion">
                <div
                  className="card"
                  data-aos="fade-up"
                  data-aos-duration={600}
                >
                  <div className="card-header" id="headingOne">
                    <h5 className="mb-0">
                      <button
                        className="btn btn-link"
                        data-toggle="collapse"
                        data-target="#collapseOne"
                        aria-expanded="true"
                        aria-controls="collapseOne"
                      >
                        1. How can I get started with DNET?
                      </button>
                    </h5>
                  </div>
                  <div
                    id="collapseOne"
                    className="collapse show"
                    aria-labelledby="headingOne"
                    data-parent="#accordion"
                  >
                    <div className="card-body">
                      Simply sign up, deposit funds, and start exploring the
                      ecosystem.
                    </div>
                  </div>
                </div>
                <div
                  className="card"
                  data-aos="fade-up"
                  data-aos-duration={600}
                >
                  <div className="card-header" id="headingTwo">
                    <h5 className="mb-0">
                      <button
                        className="btn btn-link collapsed"
                        data-toggle="collapse"
                        data-target="#collapseTwo"
                        aria-expanded="false"
                        aria-controls="collapseTwo"
                      >
                        2. Is DNET secure?
                      </button>
                    </h5>
                  </div>
                  <div
                    id="collapseTwo"
                    className="collapse"
                    aria-labelledby="headingTwo"
                    data-parent="#accordion"
                  >
                    <div className="card-body">
                      Yes, DNET leverages the security and transparency of
                      Arbitrum blockchain for all transactions.
                    </div>
                  </div>
                </div>
                <div
                  className="card"
                  data-aos="fade-up"
                  data-aos-duration={600}
                >
                  <div className="card-header" id="headingThree">
                    <h5 className="mb-0">
                      <button
                        className="btn btn-link collapsed"
                        data-toggle="collapse"
                        data-target="#collapseThree"
                        aria-expanded="false"
                        aria-controls="collapseThree"
                      >
                        3. What are the benefits of using DNET?
                      </button>
                    </h5>
                  </div>
                  <div
                    id="collapseThree"
                    className="collapse"
                    aria-labelledby="headingThree"
                    data-parent="#accordion"
                  >
                    <div className="card-body">
                      DNET provides AI-driven financial optimization,
                      decentralized security, and fast transactions.
                    </div>
                  </div>
                </div>
                {/* <div
                  className="card mb-0"
                  data-aos="fade-up"
                  data-aos-duration={600}
                >
                  <div className="card-header" id="headingfour">
                    <h5 className="mb-0">
                      <button
                        className="btn btn-link collapsed"
                        data-toggle="collapse"
                        data-target="#collapsefour"
                        aria-expanded="false"
                        aria-controls="collapsefour"
                      >
                        How can I get the best results?
                      </button>
                    </h5>
                  </div>
                  <div
                    id="collapsefour"
                    className="collapse"
                    aria-labelledby="headingfour"
                    data-parent="#accordion"
                  >
                    <div className="card-body">
                      Lorem ipsum dolor sit amet, consectetur adipiscing elit,
                      sed do tempor incididunt ut labore et dolore magna aliqua.
                      Quis ipsum suspendisse ultrices gravida.
                    </div>
                  </div>
                </div> */}
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default FAQs;
